<template>
  <div class="flex justify-center">
    <div class="flex items-center justify-center rounded-full h-[25px] w-[25px] mb-2">
      <img src="@/assets/dashboard/wallet.svg" class="h-[25px] w-[25px]" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
